import RestClientService from "@/core/services/restClient.service";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import { FARE_MANAGEMENT_API_PATH } from "../constants";

class FareManagemenentService {
  private restClient: RestClientService;

  constructor() {
    this.restClient = new RestClientService();
  }

  public getFares(
    pnr: string,
    airline_code: string,
    financial_profile: string,
  ): Promise<ICoreResponse> {
    return this.restClient.get(
      FARE_MANAGEMENT_API_PATH.GET_FARE +
        `?pnr=${pnr}&airline_code=${airline_code}&financial_profile_public_id=${financial_profile}`,
    );
  }
  public saveFares(reference: string): Promise<ICoreResponse> {
    return this.restClient.post(FARE_MANAGEMENT_API_PATH.GET_FARE, {
      reference: reference,
    });
  }
}

export default FareManagemenentService;
